import React, {useEffect, useState} from 'react';
import './App.css';
import {MsalProvider, useMsal} from '@azure/msal-react';

import {BimaireAdMultitenantClient, IKovaUserInfo, KovaUserClient} from "@bimaire/kova-api-client";

/*const adClient = new BimaireAdB2cClient({
    clientId: "72cfb6d4-cc9b-4734-afca-225c9ebbe520",
    b2cTenant: "bimairedevb2c",
    apiScope: "https://bimairedevb2c.onmicrosoft.com/9d1d4433-80fa-4ab9-8c54-a5307dcb7c7f/kova.getuser"
});*/

const adClient = new BimaireAdMultitenantClient({

    clientId: "0af0f236-583c-485f-bffe-923f70f9e281",
    apiScope: "https://bimaire.com/api/KovaApi/Kova.ReadAccount"
});
const localAuth = "https://localhost:7141";
const prodAuth = "https://kovaapi.bimaire.app";
const kovaUserClient = new KovaUserClient({ kovaAuthEndpoint: prodAuth });
const envName = "GoodallQA";


function LoginExample() {

    const msal = useMsal();
    const [inProgress, setInProgress] = useState(false);
    const [kovaUserInfo, setKovaUserInfo] = useState<IKovaUserInfo | null>(null);

    const onLogin = async () => {
        try {
            setInProgress(true);

            const kovaToken = await adClient.getTokenForKovaAuth(msal);
            const getKovaInfoResponse = await kovaUserClient.getKovaInfo(kovaToken, envName, ["BSSUser.AccessUI", "AdminPortal-Access", "BUnit.View"]);
            if (getKovaInfoResponse.success) {
                setKovaUserInfo(getKovaInfoResponse.userInfo);
            }
        } finally {
            setInProgress(false);
        }

    }
    return (<div>
            <div>Hello!</div>
            {!inProgress && kovaUserInfo === null && <button onClick={onLogin}>Login to AnttiDev</button>}
            {inProgress && <p>Logging in...</p>}
            {kovaUserInfo && <p>Kova user {kovaUserInfo.kovaUsername} @ {kovaUserInfo.environmentId} with
                permissions {kovaUserInfo.permissions.join(", ")}</p>}
        </div>
    );
}
function App() {

    return (
        <MsalProvider instance={adClient.getMsalPublicClientApplication()}>
            <LoginExample />
        </MsalProvider>
    );
}

export default App;
